module.exports = __webpack_public_path__ + "img/zzjg.879fa1ca.png";